import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr'

const client = new HubConnectionBuilder()
  // eslint-disable-next-line no-template-curly-in-string
  .withUrl('https://realtimequiz.azurewebsites.net/quizHub')
  .withAutomaticReconnect()
  .configureLogging(LogLevel.Information)
  .build()

export default function createWebSocket () {
  return store => {
    client.on('stateChanged', (oldState, newState) => {
      if (oldState !== newState && newState !== 'Connected') {
        store.dispatch('quiz/connectionClosed')
      } else {
        store.dispatch('quiz/connectionOpened')
      }
    })

    // Reconnecting event
    client.onreconnecting(err => {
      store.dispatch('quiz/connectionError', 'Connectie verbroken door deze error: ' + err + '. Bezig met opnieuw verbinden.')
    })
    client.onreconnected(() => {
      store.dispatch('quiz/connectionOpened')
    })
    client.onclose(error => {
      store.dispatch('quiz/connectionFailed', error)
    })

    // subscribe to gamestate event from server
    client.on('GameUpdate', gameState => {
      store.dispatch('quiz/updateGamestate', JSON.parse(gameState))
    })
    client.on('GameCreated', game => {
      console.log(JSON.parse(game))
      store.dispatch('quiz/setCreatedGame', JSON.parse(game))
    })
    client.on('GameStarted', game => {
      console.log(JSON.parse(game))
      store.dispatch('quiz/setCreatedGame', JSON.parse(game))
    })
    client.on('GameStartedClient', () => {
      store.dispatch('quiz/gameStarted')
    })
    client.on('SelectedQuiz', quiz => {
      store.dispatch('quiz/setQuiz', JSON.parse(quiz))
    })
    client.on('UserGuid', guid => {
      store.dispatch('quiz/setUserGuid', guid)
    })
    client.on('ShowWaitScreen', () => {
      store.dispatch('quiz/showWaitScreen')
    })
    client.on('NewQuestion', question => {
      store.dispatch('quiz/getNextQuestion', JSON.parse(question))
    })
    client.on('JoinedGame', game => {
      store.dispatch('quiz/setJoinedGame', game)
    })
    client.on('Tick', tick => {
      store.dispatch('quiz/setTick', JSON.parse(tick))
    })
    client.on('PoinsUpdated', tick => {
      store.dispatch('quiz/updateGameScore', JSON.parse(tick))
    })
    client.on('GivenAnswers', answers => {
      store.dispatch('quiz/updateGivenAnswers', JSON.parse(answers))
    })
    client.on('UserPoints', answers => {
      store.dispatch('quiz/setUserPoints', JSON.parse(answers))
    })
    // subscribe to all events in the store
    store.subscribe((mutation, state) => {
      if (state.quiz.connected) {
        // see which event to do
        switch (mutation.type) {
          case 'quiz/SET_JOIN_GAME':
            console.log('invoke set join game')
            client.invoke('JoinGame', parseInt(state.quiz.joinGame.gameid), state.quiz.joinGame.username, state.quiz.joinGame.district, parseInt(state.quiz.joinGame.age), state.quiz.joinGame.gender)
              .catch(err => {
                store.dispatch('quiz/setGameError', err)
              })
            break
          case 'quiz/SET_JOIN_SCORE':
            console.log('invoke set join score')
            client.invoke('JoinScore', parseInt(state.quiz.joinGame.gameid))
              .catch(err => {
                store.dispatch('quiz/setGameError', err)
              })
            break
          case 'quiz/SET_CREATE_GAME':
            console.log('invoke set create game')
            client.invoke('CreateGame', state.quiz.createGame.username, state.quiz.createGame.district, parseInt(state.quiz.createGame.age), state.quiz.createGame.gender)
              .catch(err => {
                store.dispatch('quiz/setGameError', err)
              })
            break
          case 'quiz/LEAVE_GAME':
            console.log('invoke leave game')
            client.invoke('LeaveGame')
              .catch(err => {
                store.dispatch('quiz/setGameError', err)
              })
            break
          case 'quiz/ANSWER_QUESTION':
            console.log('invoke answer question')
            client.invoke('AnswerQuestion', state.quiz.answer)
              .catch(err => {
                store.dispatch('quiz/setGameError', err)
              })
            break
          // Admin functions
          case 'quiz/SET_QUIZNAME':
            console.log('invoke set quiz')
            client.invoke('SetQuiz', state.quiz.quizname)
              .catch(err => {
                store.dispatch('quiz/setGameError', err)
              })
            break
          case 'quiz/START_GAME':
            console.log('invoke start game')
            client.invoke('StartGame')
              .catch(err => {
                store.dispatch('quiz/setGameError', err)
              })
            break
          case 'quiz/NEXT_QUESTION':
            console.log('invoke next question')
            client.invoke('NextQuestion')
              .catch(err => {
                store.dispatch('quiz/setGameError', err)
              })
            break
          case 'quiz/SEND_CACHED_USER_GUID':
            client.invoke('SendCachedUserGuid', state.quiz.userGuid)
            break
        }
      }
    })

    // eslint-disable-next-line no-unused-vars
    async function start () {
      try {
        await client.start()
        store.dispatch('quiz/connectionOpened')
      } catch (err) {
        store.dispatch('quiz/connectionError', err)
        setTimeout(() => start(), 10000)
      }
    }
    start()
    /* client
      .start()
      .then(() => {
        store.dispatch('connectionOpened')
      })
      .catch(err => {
        store.dispatch('connectionError', err)
      })
      */
  }
}
